module.exports = __webpack_public_path__ + "static/media/YF62_2.31151a61.jpg";